module.exports = __webpack_public_path__ + "img/location.b3e5f271.svg";